import gql from 'graphql-tag';
import { USER_FIELDS } from '../users/queries';
import { VotingAreaFields } from '../voting_areas/queries';

const CAMPAIGN_FIELDS = gql`
  fragment CampaignFields on ri_apps_prd_campaigns {
    campaign_id
    organization_id
    name
    #status
    status_id
    campaigns_status {
      status_id
      name
      code
    }
    #voting_area
    campaigns_campaign_voting_areas {
      campaign_voting_areas_voting_area {
        voting_area_id
        ...VotingAreaFields
      }
    }
    purpose
    start_date
    end_date
    #summary_tags
    campaigns_campaign_tags {
      campaign_tags_c_tag {
        c_tag_id
        title
      }
      campaign_tags_org_tag {
        org_tag_id
        title
        organization_id
      }
    }
    #contact_fields
    campaigns_campaign_contact_options {
      campaign_contact_options_contact_option {
        contact_option_id
        name
      }
    }
    campaigns_organization {
      organization_id
      name
      sms_provider
    }
  }
  ${VotingAreaFields}
`;

export const GET_CAMPAIGNS = gql`
  query GetCampaigns($orgId: Int!) {
    rows: ri_apps_prd_campaigns(where: { organization_id: { _eq: $orgId } }) {
      ...CampaignFields
    }
    org: ri_apps_prd_organizations_by_pk(organization_id: $orgId) {
      organization_id
      name
    }
  }
  ${CAMPAIGN_FIELDS}
`;

export const GET_CAMPAIGNS_FOR_ORG = gql`
  query GetCampaignsForOrg($org_id: Int!) {
    rows: ri_apps_prd_campaigns(where: { organization_id: { _eq: $org_id } }) {
      campaign_id
      name
      campaigns_task_campaigns {
        task_campaigns_task {
          task_id
          name

          tasks_task_results {
            task_results_t_result {
              t_result_id
            }
          }
        }
      }
      campaigns_user_campaigns {
        user_campaigns_user {
          user_id
          first_name
          last_name
        }
      }
    }
  }
`;

export const GET_USER_CAMPAIGNS = gql`
  query GetUserCampaigns(
    $where: ri_apps_prd_campaigns_bool_exp = {}
    $order_by: [ri_apps_prd_campaigns_order_by!]
  ) {
    rows: ri_apps_prd_campaigns(
      where: { _and: [$where, { status_id: { _eq: 1 } }] }
      order_by: $order_by
    ) {
      ...CampaignFields
      campaigns_task_campaigns(
        where: { task_campaigns_task: { bulk_task_id: { _is_null: true } } }
      ) {
        task_campaigns_task {
          task_id
          name
          tasks_task_results_aggregate {
            aggregate {
              count
            }
          }
          tasks_sub_tasks {
            tasks_task_results_aggregate {
              aggregate {
                count
              }
            }
          }
        }
      }
      campaigns_user_campaigns {
        user_campaigns_user {
          user_id
          first_name
          last_name
        }
      }
    }
  }
  ${CAMPAIGN_FIELDS}
`;

export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign($data: ri_apps_prd_campaigns_insert_input!) {
    row: insert_ri_apps_prd_campaigns_one(object: $data) {
      ...CampaignFields
    }
  }
  ${CAMPAIGN_FIELDS}
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($campaign_id: Int!, $data: ri_apps_prd_campaigns_set_input!) {
    row: update_ri_apps_prd_campaigns_by_pk(
      pk_columns: { campaign_id: $campaign_id }
      _set: $data
    ) {
      ...CampaignFields
    }
  }
  ${CAMPAIGN_FIELDS}
`;

export const GET_CAMPAIGN = gql`
  query GetCampaign($campaign_id: Int!) {
    row: ri_apps_prd_campaigns_by_pk(campaign_id: $campaign_id) {
      ...CampaignFields
      campaigns_campaign_voting_areas {
        campaign_voting_area_id
        campaign_id
        voting_area_id
      }
    }
  }
  ${CAMPAIGN_FIELDS}
  ${VotingAreaFields}
`;

export const GET_CAMPAIGN_USERS = gql`
  query GetCampaign($campaign_id: Int!) {
    row: ri_apps_prd_campaigns_by_pk(campaign_id: $campaign_id) {
      name
      campaigns_campaign_voting_areas {
        campaign_voting_area_id
        campaign_id
        voting_area_id
      }
      campaigns_user_campaigns(
        where: {
          user_campaigns_user_organizations: { user_organizations_role: { role_id: { _eq: 34 } } }
        }
      ) {
        ${USER_FIELDS}
      }
    }
  }
`;

export const ADD_USER_CAMPAIGNS = gql`
  mutation AddUserCampaigns($data: [ri_apps_prd_user_campaigns_insert_input!]!) {
    rows: insert_ri_apps_prd_user_campaigns(objects: $data) {
      affected_rows
    }
  }
`;

export const DELETE_USER_CAMPAIGNS = gql`
  mutation DeleteUserCampaigns($ids: [Int!]!) {
    rows: delete_ri_apps_prd_user_campaigns(where: { campaign_id: { _in: $ids } }) {
      affected_rows
    }
  }
`;

export const GET_CAMPAIGNS_BY_TASK = gql`
  query getCampaignsByTask($task_id: Int!) {
    rows: ri_apps_prd_campaigns(
      where: { campaigns_task_campaigns: { task_id: { _eq: $task_id } } }
      distinct_on: [name]
      order_by: [{ name: asc }]
    ) {
      name
      campaign_id
    }
  }
`;

export const GET_CAMPAIGNS_LIST = gql`
  query GetCampaigns($where: ri_apps_prd_campaigns_bool_exp) {
    rows: ri_apps_prd_campaigns(where: $where) {
      ...CampaignFields
    }
  }
  ${CAMPAIGN_FIELDS}
`;
